/**
 * 한국 창고 기준 오전 11시(11:00 KST) 주문 마감 카운트다운
 */
function updateOrderDeadline() {
  var nowUtc = new Date();
  var nowInKR = new Date(nowUtc.toLocaleString("en-US", { timeZone: "Asia/Seoul" }));
  
  var krYear = nowInKR.getFullYear();
  var krMonth = nowInKR.getMonth();
  var krDate = nowInKR.getDate();
  
  // KST 11:00 = UTC 02:00
  var cutoffUtc = new Date(Date.UTC(krYear, krMonth, krDate, 2, 0, 0));
  
  if (nowInKR.getHours() >= 11) {
    var nextDay = new Date(nowInKR.getTime() + 86400000);
    cutoffUtc = new Date(Date.UTC(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate(), 2, 0, 0));
  }
  
  var diff = cutoffUtc - nowUtc;
  if (diff < 0) diff = 0;
  
  var hours = Math.floor(diff / (1000 * 60 * 60));
  var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  var secs = Math.floor((diff % (1000 * 60)) / 1000);
  
  var el = document.getElementById("deadline-countdown");
  if (el) el.textContent = hours + " Hrs " + mins + " Mins " + secs + " Secs";
  
  var cartEl = document.getElementById("cart-deadline-countdown");
  if (cartEl) cartEl.textContent = hours + " Hrs " + mins + " Mins " + secs + " Secs";
}

setInterval(updateOrderDeadline, 1000);
updateOrderDeadline();
